module.exports = __webpack_public_path__ + "img/mg.9dc1916f.svg";